export const rules = {
  title: [
    { required: true, message: 'Пожалуйста укажите наименование', trigger: 'blur' },
  ],
  state: [
    { required: true, message: 'Пожалуйста укажите состояние', trigger: 'blur' },
  ],
};